export const AccountStatusEnum = {
  disabled: "disabled",
  enabled: "enabled",
  incomplete: "incomplete",
  unverified: "unverified",
  invited: "invited",
  pastDue: "pastDue",
  frozen: "frozen",
}
